module.exports = __webpack_public_path__ + "static/media/report_inactive.0e0a98b7.svg";